var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatCategory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4972_8444)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4972_8444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4972_8444)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.35352C0 1.0591 1.04933 0.00976562 2.34375 0.00976562H8.55567C9.85008 0.00976562 10.8994 1.0591 10.8994 2.35352V8.58191C10.8994 9.87636 9.85008 10.9257 8.55567 10.9257H2.34375C1.04933 10.9257 0 9.87636 0 8.58191V2.35352Z",
    fill: "#4F565E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.4278C0 14.1333 1.04933 13.084 2.34375 13.084H8.55567C9.85008 13.084 10.8994 14.1333 10.8994 15.4277V21.6562C10.8994 22.9506 9.85008 23.9999 8.55567 23.9999H2.34375C1.04933 23.9999 0 22.9506 0 21.6562V15.4278Z",
    fill: "#4F565E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4443 0.00976562C14.1499 0.00976562 13.1006 1.0591 13.1006 2.35352V8.58191C13.1006 9.87636 14.1499 10.9257 15.4443 10.9257H21.6562C22.9507 10.9257 24 9.87636 24 8.58191V2.35352C24 1.0591 22.9507 0.00976562 21.6562 0.00976562H15.4443Z",
    fill: "#4F565E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1006 15.4278C13.1006 14.1333 14.1499 13.084 15.4443 13.084H21.6562C22.9507 13.084 24 14.1333 24 15.4277V21.6562C24 22.9506 22.9507 23.9999 21.6562 23.9999H15.4443C14.1499 23.9999 13.1006 22.9506 13.1006 21.6562V15.4278Z",
    fill: "#4F565E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4972_8444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatCategory);
export default __webpack_public_path__ + "static/media/chat-category.d90108009bceec2147ed2cbf85eaf9fe.svg";
export { ForwardRef as ReactComponent };